
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { FaUser, FaCog, FaSignOutAlt } from "react-icons/fa";
import styles from "../styles/Navbar.module.css";
import SearchBar from "./SearchBar";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

export default function Navbar() {
  const navigate = useNavigate();
  const { currentUser: user, logout } = useAuth();
  const [searchTerm, setSearchTerm] = useState("");
  const [showMenu, setShowMenu] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const menuRef = useRef(null);

  useEffect(() => {
    if (user?.uid) {
      setProfileImage(user.photoURL); // Default to Auth photo
      const unsub = onSnapshot(doc(db, "users", user.uid), (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          if (data.avatar) {
            setProfileImage(data.avatar);
          }
        }
      });
      return () => unsub();
    }
  }, [user]);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const handleSearch = (e) => {
    if (e.key === 'Enter') {
      console.log("Searching for:", searchTerm);
    }
  }

  // Close menu when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuRef]);

  return (
    <nav className={styles.navbar}>
      <div className={styles.content}>
        {/* Brand */}
        <div className={styles.logoSection} onClick={() => navigate("/feed")} style={{ cursor: 'pointer' }}>
          <span className={styles.logoText}>
            Intra<span className={styles.logoAccent}>Uni</span>
          </span>
        </div>

        {/* Search */}
        <div className={styles.searchSection}>
          <SearchBar />
        </div>

        {/* Actions */}
        <div className={styles.actionsSection}>
          {user ? (
            <>
              {/* Profile Dropdown */}
              <div className={styles.userMenu} ref={menuRef} onClick={() => setShowMenu(!showMenu)}>
                <img
                  src={profileImage || `https://ui-avatars.com/api/?name=${user.email}&background=random`}
                  alt="Profile"
                  className={styles.avatar}
                />

                {showMenu && (
                  <div className={styles.dropdown}>
                    <div className={styles.menuItem} onClick={() => navigate(`/profile/${encodeURIComponent(user.email)}`)}>
                      <FaUser /> Profile
                    </div>
                    <div className={styles.menuItem} onClick={() => navigate("/settings")}>
                      <FaCog /> Settings
                    </div>
                    <div className={`${styles.menuItem} ${styles.menuItemLogout}`} onClick={handleLogout}>
                      <FaSignOutAlt /> Logout
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <button className={styles.navLink} onClick={() => navigate("/login")}>
              Login
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}